<div>
  <span>{{messagePartA}}</span>
  <a class="id37-link" (click)="goToCustomers()">{{userName}}</a>
  <span>{{messagePartB}}</span>
  <a class="id37-link" (click)="goToProfile()">{{report}}</a>
  <span>{{messagePartC}}</span>
</div>
